App.filter('newlines', function () {
    return function(text) {
        if(text)
            return text.replace(/\r\n|\n/gi, ' ');
    }
});
App.filter('numberFormater', function () {
    return function (input) {
      /*  console.log(input);*/
        var strNo = JSON.stringify(input).split('');
        strNo.splice(4, 0, '-');
        strNo.splice(8, 0, '-');
        strNo.shift();
        strNo.pop();
        return strNo.join('');
    }
});